/* eslint-disable */
import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME, FILEURL, MILLISECONDSINADAY, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { utility } from "../../framework/utility/utilityProvider";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import { useTranslation } from "../../locale/useTranslation";
import moment from "moment";
import ToastNotification from "../../components/ToastNotification";
import BossDialog from "../../components/BossDialog";
import { useNavigate } from "react-router-dom";

const URFReport = () => {

    const defaultDates = utility.getFirstAndLastDateOfMonth();

    const blankDataItem = {
        startDate: defaultDates.FirstDate,
        endDate: defaultDates.LastDate,
        Channel: {},
    }

    const lang = useTranslation();
    const navigate = useNavigate();
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [channels, setChannels] = useState([]);
    const [footerMessage, setFooterMessage] = useState('');
    const [isExporting, setIsExporting] = useState(false);

    useEffect(() => {
        loadcombo();
    }, []);

    const loadcombo = async () => {
        let channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannels(channelRes?.data || []);
        if (channelRes?.data && channelRes?.data?.length > 0) {
            setDataItem(prev => ({ ...prev, Channel: channelRes?.data[0] }));
        }
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    };

    const isValid = () => {
        if (dataItem.startDate == undefined || dataItem.startDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date_error_message });
            return false;
        }
        if (dataItem.endDate == undefined || dataItem.endDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
            return false;
        }
        if (dataItem.Channel == undefined || Object.keys(dataItem.Channel).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }
        return true
    }

    const downloadExcel = async () => {

        if (!isValid()) return;

        setIsExporting(true);
        setFooterMessage(lang.please_wait_export_message || "Please wait for the Exporting...");

        let payload = {
            startDate: utility.convertStringDatetoMilliseconds(dataItem?.startDate),
            endDate: utility.convertStringDatetoMilliseconds(dataItem?.endDate) + MILLISECONDSINADAY - 1000,
            channelSID: dataItem?.Channel?.SID
        }

        const res = await API.exportUbsUrfReport(payload);
        console.log(res);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
            setFooterMessage(lang.successfully_download_success_message || "");
            setIsExporting(false);
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            setFooterMessage(res.message || '');
            setIsExporting(false);
        }

    }

    return (<>
        <BossDialog
            title={lang.urf_report_header}
            onClose={() => navigate(-1)}
            width={"750px"}
        >
            <div className="row m-1">
                <div className="col-12">
                    <div className="row">
                        <div className="col">
                            <ActionButton disabled={isExporting} name={lang.export_button_text || "Export"} title={lang.export_button_tooltip || lang.download_button_tooltip} onClick={() => downloadExcel()} btnColor={'primary'} style={{ marginLeft: '0px', borderRadius: '5px' }} />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-4">
                            <label className="form-label">{lang.from_date_label} *</label>
                            <input type="date" className="form-control form-control-sm" name="startDate" value={dataItem.startDate} onChange={onChange} disabled={isExporting} />
                        </div>
                        <div className="col-4">
                            <label className="form-label">{lang.to_date_label} *</label>
                            <input type="date" className="form-control form-control-sm" name="endDate" value={dataItem.endDate} onChange={onChange} disabled={isExporting} />
                        </div>
                        <div className="col-4">
                            <label className="form-label">{lang.channel_label} *</label>
                            <DropDownList
                                data={channels}
                                textField="FullChannelName"
                                dataItemKey="SID"
                                name="Channel"
                                onChange={onChange}
                                value={dataItem.Channel}
                                disabled={isExporting}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='text-right mt-3' style={{ position: 'fixed', height: '30px', width: '752px', marginLeft: '-20px', padding: '5px', background: "#3A3633" }}>
                <span style={{ color: 'white' }}>{footerMessage} </span>
            </div>
        </BossDialog>
    </>)
}
export default URFReport;